import React from 'react'
import { useEffect, useState, useMemo, useRef } from 'react';
import '../App.css';
import '../Assets/css/Main.css'
import { Col, Row, CardHeader, Button } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import base from '../Services/BaseService'
import LoadSpinner from './Shared/Loading'
import CategoryModal from './CategoryModal'
import Grid, { defaultGridColumnDef } from './Shared/Grid';
import { IoAddOutline } from 'react-icons/io5';
import { FormatCurrencyCell } from './Functions/NumberFormatter';

const Category = () => {

    const gridRef = useRef();
    const [data, setData] = useState([]);
    const [saveItem, setSaveItem] = useState();
    const [catID, setCatID] = useState();
    const [showModal, setShowModal] = useState(false)
    const [expLoading, setExpLoading] = useState(true);

    const budgetColDef = useMemo(() => [
            {
                headerName: "Category",
                field: "categoryId",
                suppressMovable: true,
                maxWidth: 100
            },
            {
                headerName: "Category Description",
                field: "categoryDescription",
                suppressMovable: true,
                maxWidth: 250
            },
            {
                headerName: "Default Amount",
                field: "defaultAmount",
                suppressMovable: true,
                filter: 'agNumberColumnFilter',
                type: 'numericColumn',
                maxWidth: 150,
                valueFormatter: FormatCurrencyCell
            }
        ], []);


    const openModal = () => {
        setShowModal(!showModal)
    }

    const openModal1 = () => {
        setCatID(0)
        setShowModal(!showModal)
    }

    const closeModal = () => {
        setShowModal(false)
    }

    useEffect(() => {
        const getdata = async () => {
            await base.getAll("Category").then((budgetRes) => {
                setData(budgetRes);
            })
                .finally(() => {
                    setExpLoading(false)
                });
        }
        getdata();
    }, [saveItem])


    const onSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length === 1) {
            setCatID(selectedRows[0].categoryId);
            openModal();
        }
    };

    return (
        <>
            <CardHeader className="pt-3 pb-3">
                <Row>
                    <Col xs="6" className="page-header">
                        Categories
                    </Col>
                    <Col xs="6" className="text-end pe-4">
                        <Button size="sm" color="dark" className="btn-text" onClick={openModal1} >
                            <IoAddOutline size={24} style={{ color: "#fff" }} />
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            {expLoading ?
                <LoadSpinner />
                :
                <div style={{ marginBottom: "0px" }}>
                    <div className="pt-2 pb-2 res-padding scroll-container">
                        <Grid onSelectionChanged={onSelectionChanged} gridDefaultColDef={defaultGridColumnDef} colDef={budgetColDef} data={data} gridRef={gridRef} >
                        </Grid>
                    </div>
                </div>
            }

            {showModal && <CategoryModal id={catID} closeModal={closeModal} setSaveItem={setSaveItem} />}

        </>
    )
}

export default Category
